import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, ShopOutlined } from '@ant-design/icons';
import VendorList from '../components/Vendors/VendorList';

const { Title } = Typography;

const VendorsPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <ShopOutlined />
                                <span>Vendors</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Vendors</Title>
            </div>

            <VendorList />
        </div>
    );
};

export default VendorsPage;

